import { twMerge } from "tailwind-merge";
import Select, { type SelectProps } from "../Select";

export type ListFiltersProps = {
  filters: {
    disabled?: boolean;
    className?: string;
    dataTestid?: string;
    placeholder: string;
    options: SelectProps['options'];
    optionClassName?: string;
    defaultValue?: SelectProps['defaultValue'];
    value?: SelectProps['value'];
    onInputChange?: (inputValue: string) => void;
    onChange: NonNullable<SelectProps['onChange']>;
    operationKlassToCheckPermission?: string;
    propertiesToCheckPermission?: string[];
    tooltipPlace?: SelectProps['tooltipPlace'];
    tooltipMessage?: SelectProps['tooltipMessage'];
    noPermissionText?: SelectProps['noPermissionText'];
  }[];
  containerClassName?: string;
};

const ListFilters = ({ filters, containerClassName }: ListFiltersProps) => {
  return (
    <div className="z-50">
      <div className={twMerge("flex gap-2 items-center justify-start", containerClassName)}>
        {filters.map((filter) => (
          <Select
            key={filter.placeholder}
            onInputChange={filter.onInputChange}
            name={filter.dataTestid}
            className={twMerge("text-xs rounded-xl bg-white-100 shadow-[0px_0px_8px_4px_rgba(0,_0,_0,_0.2)]", filter.className)}
            badge
            placeholder={filter.placeholder}
            defaultValue={filter.defaultValue}
            value={filter.value || null}
            onChange={filter.onChange}
            options={filter.options}
            optionClassName={filter.optionClassName}
            isDisabled={filter.disabled}
            operationKlassToCheckPermission={filter.operationKlassToCheckPermission}
            propertiesToCheckPermission={filter.propertiesToCheckPermission}
            tooltipPlace={filter.tooltipPlace}
            tooltipMessage={filter.tooltipMessage}
            noPermissionText={filter.noPermissionText}
          />
        ))}

      </div>
    </div>
  );
};

export default ListFilters;
